import {ReactNode} from 'react';

export const TableCell = ({children, isFixed = false}: {children?: ReactNode; isFixed?: boolean}) => {
  return <td className={`p-2 ${isFixed ? 'border-r-2 border-sw-border-light' : ''}`}>{children}</td>;
};
